import { useQuery } from '@tanstack/react-query';
import { fetchLabTests } from './labsApi';

const LAB_TESTS_QUERY_KEY = ['labs', 'tests'] as const;

/** The org's lab catalog; only mounted behind the ordering gate. */
export const useLabTests = () =>
  useQuery({
    queryKey: LAB_TESTS_QUERY_KEY,
    queryFn: fetchLabTests,
    staleTime: 60 * 60 * 1000,
  });
